import { useState, useEffect } from "react";
import ReactTooltip from "react-tooltip";
import $ from "jquery";
import Constants from "../../Constants";

export default function CustomToolTips(props) {
  const { toolTipRef, toolTipId, dataTip } = props;
  const [refs, setRefs] = useState({});

  useEffect(() => {
    if (refs.current) {
      refs.current.hideTooltip();
      setRefs({});
    }
  }, [refs]);

  $("p").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      if ($(this).attr("id") === toolTipId) {
        setRefs(toolTipRef);
      }
    }
  });

  return (
    <>
      <p
        className="inline-flex ml-6 mb-0 gb-focus"
        tabIndex={0}
        data-events={["focus"]}
        data-eventsoff={["blur"]}
        data-padding="10px 10px 10px 10px"
        data-place="right"
        data-tip={dataTip}
        data-for="settings-dept-tooltip"
        id={toolTipId}
        aria-label="Tooltip">
        <svg className="svg-tooltip-icon m-0" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
        </svg>
        <div className="font-zero">{dataTip}</div>
      </p>
      <ReactTooltip className="tooltip" id="settings-dept-tooltip" role="tooltip" ref={toolTipRef} />
    </>
  );
}
